import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';

import { ImageRow } from '../';

import './ImageEditor.scss';

class ImageEditor extends Component {
  rows(assetsList) {
    const selectables = Object.entries(assetsList || {});

    if (this.props.showNewSelectableRow) {
      selectables.push([undefined, undefined]);
    }
    const activeRows = selectables.filter(function(selectable) {
      return selectable[1].status === 'ACTIVE';
    });
    const disableAllowed = activeRows.length > 1;
    return selectables.map((selectable, index) => {
      return (
        <ImageRow
          id={`selectable${index}-${selectable[1].id}`}
          key={`selectable${index}-${selectable[1].id}`}
          actions={this.props.actions}
          selectable={selectable[1]}
          disableAllowed={disableAllowed}
          onSelectableChange={(element, value) =>
            this.props.onSelectableChange(selectable, element, value)
          }
          onDeleteSelectable={() => this.props.onDeleteSelectable(selectable)}
          onDisableSelectable={() => this.props.onDisableSelectable(selectable)}
          status={this.props.status}
        />
      );
    });
  }

  render() {
    return (
      <section className="image-editor">
        <div className="image-rows">{this.rows(this.props.selectables)}</div>
      </section>
    );
  }
}

ImageEditor.propTypes = {
  actions: PropTypes.object,
  selectables: PropTypes.array,
  onSelectableChange: PropTypes.func.isRequired,
  onAddSelectable: PropTypes.func.isRequired,
  onDeleteSelectable: PropTypes.func.isRequired,
  onDisableSelectable: PropTypes.func.isRequired,
  showNewSelectableRow: PropTypes.bool,
  canAddSelectable: PropTypes.bool,
  status: PropTypes.string,
  intl: intlShape.isRequired
};

export default injectIntl(ImageEditor);
